import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsListOfUnitsList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsListOfUnits/ReportsListOfUnitsList/ReportsListOfUnitsList"
    )
);
export const ReportsListOfUnits = () => {
  return (
    <Layout>
      <ReportsListOfUnitsList />
    </Layout>
  );
};
